import { render } from "./ActivityNewPhoneCallDialog.vue?vue&type=template&id=5dbd24a5"
import script from "./ActivityNewPhoneCallDialog.vue?vue&type=script&lang=js"
export * from "./ActivityNewPhoneCallDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__